import { _shortcutService } from '../containers/shortcuts/service/keyboard-shortcuts.service';

export const getKeyFromCommand = (command: string) => _shortcutService.getKeyFromCommand(command);

export const attachListener = (bindings, options) => _shortcutService.listen(bindings, options);
